<script>
import Layout from '@layouts/main'
import api from '@utils/api'
import GoodsDelete from './goods-item-delete'
import GoodsNew from './goods-item-new'
import Filters from '@views/filters-dialog'
import goodsModel from '@src/models/goods'
import loadCsv from './load-csv'
import TablePaginator from '@components/paginator'
import ButtonExport from '@components/buttons/dictionary-export'
import ButtonImport from '@components/buttons/dictionary-import'
import userHasRolesToWrite from '@utils/userPermissions'
import AdjustColumnsDialog from '@components/adjust-columns-dialog'
import { hideValues, updateColumns } from '@utils/helpers/columns'

export default {
  name: 'Goods',
  components: {
    Layout,
    GoodsDelete,
    GoodsNew,
    Filters,
    loadCsv,
    TablePaginator,
    ButtonExport,
    ButtonImport,
    AdjustColumnsDialog,
  },
  data() {
    return {
      modelName: 'goods',
      isLoading: false,
      headers: [
        { text: 'short_name', value: 'shortName', sortable: true },
        { text: 'full_name', value: 'fullName', sortable: true, show: true },
        { text: 'status', value: 'status', sortable: true, show: true },
        {
          text: 'description',
          value: 'description',
          sortable: true,
          show: true,
        },
        { text: 'employer', value: 'employer', sortable: true, show: true },
        { text: 'group', value: 'group', sortable: true, show: true },
        {
          text: 'article_number',
          value: 'articleNumber',
          sortable: true,
          show: true,
        },
        { text: 'actions', value: 'actions', sortable: false },
      ],
      rowsPerPage: [10, 25, 50],
      rolesAllowedToWrite: ['SUPERUSER', 'DICTIONARIES_OPERATOR'],
      page: 1,
      totalPages: 0,
      sortBy: 'shortName',
      descending: false,
      first: false,
      last: false,
      content: [],
      pagination: {},
      totalElements: 0,
      newGoods: false,
      showFilters: false,
      multiSelect: true,
      model: goodsModel,
      filters: null,
      loadCSV: false,
      fab: false,
      showDialog: false,
      selected: [],
    }
  },
  computed: {
    params() {
      return {
        size: this.pagination.rowsPerPage || null,
        page: this.page || null,
        sort_property: this.sortBy || null,
        sort_direction: this.descending || null,
        ...this.filters,
      }
    },
    userAllowedToCreate() {
      return userHasRolesToWrite(
        this.$store.state.auth.userRole,
        this.rolesAllowedToWrite
      )
    },
    getHeaders() {
      return userHasRolesToWrite(
        this.$store.state.auth.userRole,
        this.rolesAllowedToWrite
      )
        ? this.headers
        : this.headers.slice(0, this.headers.length - 1)
    },
  },
  watch: {
    pagination: {
      handler() {
        this.$store.commit('pagination/SET', {
          name: this.modelName,
          pagination: {
            page: this.page,
            rowsPerPage: this.pagination.rowsPerPage,
            sortBy: this.sortBy,
            descending: this.descending,
          },
        })
      },
      deep: true,
    },
  },
  created() {
    this.getPaginator()
    this.getFilters()
  },
  methods: {
    fetchData() {
      this.isLoading = true
      api
        .getGoods(this.params)
        .then(response => {
          this.content = response.content
          this.totalPages = response.totalPages
          this.first = response.first
          this.last = response.last
          this.page = response.number + 1
          this.pagination = {
            ...this.pagination,
            page: 1,
            rowsPerPage: response.size,
            sortBy: this.sortBy,
            descending: this.descending,
          }
        })
        .catch(() => {})
        .then(() => {
          this.isLoading = false
        })
    },
    getValue(dictionaryName, value) {
      return this.$store.getters['data/getValueFromDictionary'](
        dictionaryName,
        value
      )
    },
    openItem(id) {
      this.$router.push(`goods/${id}`)
    },
    getFilters() {
      const filter = this.$store.getters['filters/getFilters'](this.modelName)
      this.filters = filter ? filter.value : null
      this.fetchData()
    },
    setFilters() {
      const filter = this.$store.getters['filters/getFilters'](this.modelName)
      this.filters = filter ? filter.value : null
      this.showFilters = false
      this.page = 1
      this.fetchData()
    },
    getPaginator() {
      const pagination = this.$store.getters['pagination/get'](this.modelName)
      if (pagination) {
        this.page = pagination.page || 1
        this.sortBy = pagination.sortBy || this.sortBy
        this.descending = pagination.descending || this.descending
        this.pagination.page = 1
        this.pagination.rowsPerPage = pagination.rowsPerPage || 10
      } else {
        this.page = 1
        this.pagination.page = 1
        this.pagination.rowsPerPage = 10
      }
    },
    changePage(value) {
      this.page = value
      this.fetchData()
    },
    changeRowsPerPage(value) {
      if (this.pagination.rowsPerPage === value) return
      this.pagination = {
        ...this.pagination,
        rowsPerPage: value,
      }
      this.page = 1
      this.$store.dispatch('pagination/saveRowsPerPage', value)
      this.fetchData()
    },
    changeSort(header) {
      if (!header.sortable) return
      if (this.sortBy === header.value) {
        this.descending = !this.descending
      } else {
        this.sortBy = header.value
        this.descending = false
      }
      this.fetchData()
    },
    getSortClass(header) {
      return [
        header.sortable ? 'column sortable' : null,
        this.pagination.descending ? 'desc' : 'asc',
        header.value === this.pagination.sortBy ? 'active' : '',
      ]
    },
    toggleAll() {
      if (this.selected.length) this.selected = []
      else this.selected = this.content.slice()
    },
    test(props) {
      this.selected.push({
        ...props.item,
      })
    },
    hideValues(field) {
      return hideValues(field, this.headers)
    },
    updateColumns(columns) {
      updateColumns(columns, this.headers)
    },
    openDialog() {
      this.showDialog = true
    },
  },
}
</script>

<template>
  <Layout>
    <div slot="actionButton">
      <div class="hidden-xs-only">
        <!-- <v-btn
          color="primary"
          @click="loadCSV = true">
          {{ $t('buttons__upload') }}
        </v-btn> -->
        <button-export 
          :items="selected" 
          entity="goods" />
        <button-export 
          :all="true" 
          entity="goods" />
        <button-import 
          entity="goods" 
          @successfully="fetchData()" />
        <v-btn 
          color="info" 
          @click="fetchData">
          <v-icon>refresh</v-icon>
        </v-btn>
        <v-btn
          :color="filters ? `success` : `info`"
          @click="showFilters = true"
        >
          <v-icon>filter_list</v-icon>
        </v-btn>
        <v-btn
          v-if="userAllowedToCreate"
          slot="activator"
          color="primary"
          @click="newGoods = true"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </div>
      <div class="hidden-sm-and-up">
        <v-speed-dial
          v-model="fab"
          direction="left"
          transition="slide-y-reverse-transition"
        >
          <v-btn
            slot="activator"
            v-model="fab"
            color="blue darken-2"
            dark
            fab
            small
            flat
          >
            <v-icon>more_vert</v-icon>
            <v-icon>close</v-icon>
          </v-btn>
          <v-btn
            v-if="userAllowedToCreate"
            color="primary"
            dark
            small
            fab
            @click="newGoods = true"
          >
            <v-icon>add</v-icon>
          </v-btn>
          <v-btn
            :color="filters ? `success` : `info`"
            small
            fab
            @click="showFilters = true"
          >
            <v-icon>filter_list</v-icon>
          </v-btn>
          <v-btn 
            color="info" 
            small 
            fab 
            @click="fetchData">
            <v-icon>refresh</v-icon>
          </v-btn>
        </v-speed-dial>
      </div>
    </div>
    <v-layout justify-end>
      <v-btn
        icon
        flat
        @click="openDialog()">
        <v-icon>view_column</v-icon>
      </v-btn>
    </v-layout>
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="content"
      :pagination="pagination"
      :total-items="totalElements"
      :loading="isLoading"
      :class="$style.sdTable"
      hide-actions
      select-all
    >
      <template 
        slot="headers" 
        slot-scope="props">
        <tr>
          <th />
          <th
            v-for="header in getHeaders"
            :key="header.text"
            :class="getSortClass(header)"
            :style="[header.show === false ? {'display': 'none'} : {'text-align': 'left'}]"
            @click="changeSort(header)"
          >
            {{ $t(`label__${header.text}`) }}
            <v-icon 
              v-if="header.sortable" 
              small>expand_less</v-icon>
          </th>
        </tr>
      </template>
      <v-progress-linear
        slot="progress"
        height="2"
        color="blue"
        background-color="#E0E0E0"
        indeterminate
      />
      <template 
        slot="items" 
        slot-scope="props">
        <tr 
          :class="$style.sdEditRow" 
          @click="openItem(props.item.id)">
          <td>
            <v-checkbox
              v-model="props.selected"
              primary
              hide-details
              @click.stop
            />
          </td>
          <td>{{ props.item.shortName }}</td>
          <td v-if="!hideValues('fullName')">{{ props.item.fullName }}</td>
          <td v-if="!hideValues('status')">{{ $t(`contactstatus.${props.item.status}.name`) }}</td>
          <td v-if="!hideValues('description')">{{ props.item.description }}</td>
          <td v-if="!hideValues('employer')">{{ getValue('organization', props.item.employer) }}</td>
          <td v-if="!hideValues('group')">{{ $t(`goodsgroup.${props.item.group}.name`) }}</td>
          <td v-if="!hideValues('articleNumber')">{{ props.item.articleNumber }}</td>
          <td v-if="userAllowedToCreate">
            <goods-delete
              :short-name="props.item.shortName"
              :goods-id="props.item.id"
              @goods-deleted="fetchData()"
            />
          </td>
        </tr>
      </template>
    </v-data-table>
    <adjust-columns-dialog
      v-model="showDialog"
      :headers="headers.filter(h => h.show !== undefined)"
      :model-name="modelName"
      @columns-updated="updateColumns"
    />
    <table-paginator
      :page="page"
      :total-pages="totalPages"
      :first="first"
      :last="last"
      :rows-per-page="pagination.rowsPerPage"
      @change-page="changePage($event)"
      @change-rows-per-page="changeRowsPerPage($event)"
    />
    <goods-new 
      :new-item="newGoods" 
      @close-modal="newGoods = false" />
    <filters
      :visible="showFilters"
      :model="model"
      :model-name="modelName"
      :multi-select="multiSelect"
      @close-modal="showFilters = false"
      @filters-confirmed="setFilters()"
    />
    <load-csv
      :dialog="loadCSV"
      @close-modal="loadCSV = false"
      @upload-complete="fetchData()"
    />
  </Layout>
</template>

<style lang="scss" module>
@import '@design';
.sdTable {
  border: 1px solid #dfdfdf;

  th {
    outline: none;
  }
}
.sdEditRow {
  cursor: pointer;
}
.sdBorder {
  border: 1px solid #dfdfdf;
  border-bottom: none;
}
</style>
